export default "__VITE_ASSET__BKSLh9kz__"